import React from 'react'
import IconError from '../../../../topics/Error/components/IconError'

const withErrorIcon = (InputComponent) => ({ errorMessage, ...props }) => {
  if (errorMessage) return <InputComponent append={<IconError errorMessage={errorMessage} />} {...props} />
  return <InputComponent {...props} />
}

export default withErrorIcon
